'use client'
import React, { ReactElement, useState } from 'react'
import HeaderCopyright from '@/components/headers/HeaderCopyright'
import Divider from '@/components/Divider'
import Navigation from '@/components/navigation/Navigation'

const NotYetOtc = (): ReactElement => {
    const [leftOpen, setLeftOpen] = useState(false)

    return (
        <React.Fragment>
            <HeaderCopyright />
            <div className="main-container">
                <Navigation />
                <Divider />
                <h1 className={'white centered-row'}>NOT YET IMPLEMENTED</h1>
                <div className="centered-text gray">
                    Over the counter token sale of the CRAZY token
                    <br />
                    Offer your token at a minimal or at least market price.
                    <br />
                    Pay with many (EVM2, cross-chain) tokens. Like Pls, NoNukes, Ethereum, BNB, etc.
                </div>
            </div>
        </React.Fragment>
    )
}

export default NotYetOtc
